import { create } from 'zustand';

type ViewMode = 'list' | 'grid' | 'map';

const STORAGE_KEY = 'scio3-screen-view-mode';
const DEFAULT_VIEW_MODE: ViewMode = 'list';

interface ScreenViewState {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  /** Back to List and forget the saved choice. Called on logout (#2874). */
  reset: () => void;
}

export const useScreenViewStore = create<ScreenViewState>((set) => ({
  viewMode: (localStorage.getItem(STORAGE_KEY) as ViewMode) || DEFAULT_VIEW_MODE,
  setViewMode: (mode) => {
    localStorage.setItem(STORAGE_KEY, mode);
    set({ viewMode: mode });
  },
  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ viewMode: DEFAULT_VIEW_MODE });
  },
}));
